import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";

import HeaderBox from "../reuseableComponents/headerBox";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import MenuCard from "../reuseableComponents/MenuCard";
import { faUsers, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import ErrorHandler from "../reuseableComponents/ErrorHandler";

const menuIcons = {
  USER_MGMT: faUsers,
  USER_REPORT: faFileCsv
};

const DDWAdminIndex = () => {
  const { loading, error, data } = useQuery(GET_APP_MENU, { variables: { menu: "ADMIN" } });
  if (loading)
    return (
      <>
        <Row>
          <Col>
            <Link to='/' cypressid='returnHome' className='hyperlink'>
              Home
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='adminIndexPage'>
              <h1 className="main-section-title">System Administration Portal</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader width='100%' />
          </Col>
        </Row>
      </>
    );
  if (error) {
    return (
      <>
        <Row>
          <Col>
            <Link to='/' className='hyperlink'>
              Home
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='adminIndexPage'>
              <h1 className="main-section-title">System Administration Portal</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row>
        <Col>
          <Link to='/' className='hyperlink'>
            Home
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='adminIndexPage'>
            <h3 style={{ color: "#fff" }}>System Administration Portal</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {data.getAppMenu.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default DDWAdminIndex;
